/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import {IxModule} from '@siemens/ix-angular';
import {Property, SubmodelElement} from '@product-passport/dpp/model';
import {TranslateOrFallbackPipe} from '../../../dpp-submodel-field/utils/translate-or-fallback.pipe';
import {DppFieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-property',
  templateUrl: './property.component.html',
  imports: [
    IxModule,
    ReactiveFormsModule,
    DppFieldLabelComponent,
    TranslateOrFallbackPipe,
  ],
})
export class PropertyComponent {
  @Input({required: true}) element!: SubmodelElement;
  @Input({required: true}) control!: AbstractControl;

  get property(): Property {
    return this.element as Property;
  }
  get formControl(): FormControl {
    return this.control as FormControl;
  }
}
